"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { env } from "~/setup/env";
import YouTubePlayer from "../../jobadvideo/youtube-eon";
export default function VideoSectionEonUk() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobad/diversity-bg.webp)`,
      backgroundSize: "cover"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="mb-8 text-center font-bold text-3xl text-white md:text-4xl lg:text-5xl">Find out more about life at E.ON</h2>;
    t2 = <YouTubePlayer thumbnailSrc="images/jobad/uk/E.ON Life.webp" videoId="nM02xzb81mU" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="w-full pointer-fine:bg-fixed px-10 py-10 md:px-10 md:py-20 print:hidden" id="video" style={t0}><div className="inner-container lg:px-32">{t1}{t2}<p className="mt-8 text-center text-lg text-white lg:text-2xl">Ready to fuel your career and the planet? Your energy. Real impact.{" "}<CustomLink blank={true} className="font-semibold underline underline-offset-2 hover:opacity-80" href="https://www.eon-uk-careers.com/en/life-at-eon.html">Explore Life at E.ON</CustomLink></p></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}